import script from "./ConfirmarEsperaView.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmarEsperaView.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmarEsperaView.vue?vue&type=style&index=0&id=437832c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-437832c6"]])

export default __exports__